import { Injectable } from '@angular/core';
import { Subject } from 'rxjs';

@Injectable({
  providedIn: 'root'
})
export class MobileService {


  isMobile: boolean;
  isMobileChanges: Subject<boolean> = new Subject<boolean>();

  constructor() {
    this.isMobile = window.innerWidth < 768;
    this.isMobileChanges.next(this.isMobile);
    window.addEventListener('resize', () => {
      this.isMobile = window.innerWidth < 768;
      this.isMobileChanges.next(this.isMobile);
    });
  }
}
